<template>
  <div class="presupuesto-interno-usuarios-propuesta">
    <b-card header= "Usuarios de la Propuesta" class="presupuesto-header">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showUsuariosPropuesta= !showUsuariosPropuesta">
        <i :class="showUsuariosPropuesta ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerUsuarios" class="mt-2" v-model="showUsuariosPropuesta">
        <b-row>
          <b-col>
            <b-table hover
                responsive="sm" 
                class="registro"
                :items="usuariosPropuesta" 
                :fields="usuariosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(usuario)="data">
                {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
              </template>
              <template v-slot:cell(asignado)="data">
                <b-form-checkbox
                    v-model="data.item.asignado"
                    :disabled="data.item.inactivo"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                </b-form-checkbox> 
              </template>
            </b-table>

          </b-col>
        </b-row>
      </b-collapse>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { mapState } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'PresupuestosInternosUsuariosPropuesta',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data () {
    return {
      usuariosFields: [
        {
          key: 'usuario',
          label: 'Usuarios',
        },
        {
          key: 'asignado',
          label: '',
          class: 'text-center'
        },
      ],

      showUsuariosPropuesta: false,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'usuariosPropuesta',
    ]),
  },  
  created() {
  },
  destroyed() {
  },
  methods: {
  },
  watch: {
  }    
}
</script>

<style>
  /* .presupuesto-interno-usuarios-propuesta .registro {
    margin-top: 30px;    
  } */
  .presupuesto-interno-usuarios-propuesta table thead th {
    border-top: none;
  }
  .presupuesto-interno-usuarios-propuesta table tr.table-inactivo {
    color: #a9a9a9;
  }
</style>